import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios"
import { useTranslation } from "react-i18next";
import { App } from "antd";
import { convertDayjsToTotalSeconds } from "../../configurations/helpers";

export const useEditExam = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const editExam = async (exam: any) => {

        exam = {
            ...exam,
            categories: exam.categories.map((category: any) => {
                if (category.id === undefined) {
                    return {id: category};
                } else {
                    return {id: category.id}
                }
            }),
            timeInSeconds: convertDayjsToTotalSeconds(exam.timeInSeconds),
        }
        try {
            await axios.put(`/api/exam/${exam.id}`, exam);
        } catch (error) {
            throw new Error(t("messages.error.examEdit"));
        }
    };

    return useMutation({
        mutationFn: editExam,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["exams"] });
            message.success(t("messages.success.editExam"));
        },
    });
}